import { render, staticRenderFns } from "./Piechart.vue?vue&type=template&id=1ae018e2&scoped=true&"
import script from "./Piechart.vue?vue&type=script&lang=js&"
export * from "./Piechart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae018e2",
  null
  
)

export default component.exports